window.customElements.define(
    "jump-to",
    class extends HTMLElement {
        private select: HTMLSelectElement | null;

        constructor() {
            super();

            this.select = this.querySelector("select");
        }

        connectedCallback() {
            this.select?.addEventListener(
                "change",
                (event) => {
                    const target = event.target as HTMLSelectElement;

                    if (target.value !== "") {
                        window.location.href = target.value;
                    }
                }
            )
        }
    },
);
